module.exports = __webpack_public_path__ + "hair-on-fire.svg";


//////////////////
// WEBPACK FOOTER
// ./images/dashboard/hair-on-fire.svg
// module id = 1219
// module chunks = 74